import {Component, OnInit} from '@angular/core';
import {AppState} from '../../../state/appState';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../../shared/models/paginated.response.model';
import {PaycardListModel} from '../../../shared/services/paycard/paycard.list.model';
import {GetPaycards} from '../../../state/actions/appState.paycards.actions';
import {OpenModalPaycardDetail} from '../../../state/actions/appState.modals.actions';
import {take, tap} from 'rxjs/operators';
import {Debounce} from 'lodash-decorators';
import {PaycardStatusEnum} from '../../../shared/services/paycard/paycard.status.enum';

@Component({
  selector: 'app-paycards',
  templateUrl: './paycards.component.html',
  styleUrls: ['./paycards.component.scss']
})
export class PaycardsComponent implements OnInit {
  @Select(AppState.paycards$) paycards$: Observable<PaginatedResponseModel<PaycardListModel>>;
  paycardStatusEnum = Object.values(PaycardStatusEnum);
  paycardStatus: PaycardStatusEnum = null;

  private paycardFilter = '';

  constructor(
    private store: Store,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(new GetPaycards());
  }

  onOpenDetails(paycardId: string) {
    this.store.dispatch(new OpenModalPaycardDetail(paycardId));
  }

  onPageSelected(page: number) {
    this.paycards$.pipe(
      take(1),
      tap(paycards => {
        this.getPaycards(page, paycards.size, this.paycardFilter, this.paycardStatus);
      })
    ).subscribe();
  }

  onSizeSelected(size: number) {
    this.paycards$.pipe(
      take(1),
      tap(paycards => {
        this.getPaycards(paycards.number, size, this.paycardFilter, this.paycardStatus);
      })
    ).subscribe();
  }

  @Debounce(1000)
  onPaycardFilterChange(paycardId: string) {
    this.paycardFilter = paycardId;
    this.paycards$.pipe(
      take(1),
      tap(paycards => {
        this.getPaycards(paycards.number, paycards.size, this.paycardFilter, this.paycardStatus);
      })
    ).subscribe();
  }

  onPaycardStatusChange(status: PaycardStatusEnum) {
    this.paycardStatus = status;
    this.paycards$.pipe(
      take(1),
      tap(paycards => {
        this.getPaycards(paycards.number, paycards.size, this.paycardFilter, this.paycardStatus);
      })
    ).subscribe();
  }

  private getPaycards(page: number, size: number, paycard: string, status: PaycardStatusEnum) {
    this.store.dispatch(new GetPaycards(page, size, paycard, status));
  }
}
